"use client"

import * as React from "react"

export function useIsAndroid() {
	const [isAndroid, setIsAndroid] = React.useState<boolean>(false)

	React.useEffect(() => {
		const userAgent =
			typeof window !== "undefined" ? window.navigator.userAgent : ""
		const android = /android/i.test(userAgent)
		setIsAndroid(android)
	}, [])

	return isAndroid
}
